module.exports = __webpack_public_path__ + "img/AccuCTP.d989029f.png";